import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  main: {
    width: "100%",
    padding: "20px 40px",
    gap: '15px',
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('sm')]: {
      padding: "20px 10px",
    },
  },

  header: {
    flex: 1,
  },

  title_header: {
    color: "#535758",
    fontWeight: 500,
    fontSize: "calc(24px + (8/1200) * 100 * 1vw)",

    [theme.breakpoints.down('sm')]: {
      marginBottom: 20,
    },
  },

  loadingCircle: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  inputText: {
    width: "100%",
    marginRight: "10px",
  },

  button: {
    width: '100%',
    display: 'flex',
    justifyContent:'flex-start'
  },

  container: {
    backgroundColor: "#fff",
    padding: "10px 30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },

  row: {
    display: 'flex',
    width: '100%',
    marginBottom: '20px',
  },

  subTitle: {
    textTransform: "uppercase",
    marginBottom: "20px",
    color: "#00619E",
  },
 
  paper: {
    minWidth: '300px',
    width: "400px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: '12px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  },

  modalHeader: {
    position: 'relative',
    width: '100%',
    height: '66px',
    padding: '20px',
    borderRadius: '10px',
    background: '#00619E',
    color: '#fff',
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'center'
  },

  cart: {
    width: '100%',
    height: '100%',
    marginBottom: '20px'
  },

  button_close: {
    position: 'absolute',
    top: '9px',
    right: '10px',
    color: '#fff',
    cursor: 'pointer',
  },

  modalContent: {
    padding: '40px 20px',
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  search: {
    background: '#ffffff',
  },
  alert: {
    width: '100%',
  },

  containerBack: {
    all: "unset",

    display: "flex",
    alignItems: "center",
    gap: "5px",
    width: "fit-content",

    marginTop: "1rem",
  },

  labelBack: {
    fontSize: "32px",
    fontWeight: 500
  },

  arrowBack: {
    width: "30px",
    height: "30px",

    "&:hover": {
      cursor: "pointer"
    },
  },
  formControl: {
    minWidth: 190,
    marginLeft: theme.spacing(2),

  },
  formControlItem: {
    alignSelf: 'flex-start',
  },
  badgeDisabled: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: 12,
    backgroundColor: '#E9EEF5',
    color: '#4B5157',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  searchRow: {
    flex: 1, 
    minWidth: 0,
    marginTop: 8,
    marginBottom: 8,

  },
  statusControl: {
    minWidth: 190,
    [theme.breakpoints.up('sm')]: {
    flex: '0 0 240px',
    maxWidth: 240,
  },
    '& .MuiFilledInput-root': {
      backgroundColor: '#fff',
      borderRadius: 4,
    },
    '& .MuiFilledInput-root:hover': {
      backgroundColor: '#fff',
    },
    '& .MuiFilledInput-root.Mui-focused': {
      backgroundColor: '#fff',
    },

    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
  },

  selectItem: {
    paddingTop:8,
    maxHeight: 50,
  }, 
  title: {
    fontWeight: 600,
    color: '#535758',
    marginTop: '15px',
  },
  divider: {
    marginBottom: '25px',
  },
  details: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '30px',
    width: '100%',
    marginBottom: '30px',

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
   bgStatusPrimary: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: 12,
    backgroundColor: '#E7F5FF',
    color: '#2E7C33',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },

  bgStatusError: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: 12,
    backgroundColor: '#FDECEA',
    color: '#611A15',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  filter: {
    display: 'flex',
    gap: '10px',
    marginBottom: '15px',
    height: '65px',

    [theme.breakpoints.down(820)]: {
      marginBottom: '10px',
    },
  },
  filterButton: {
    height: '40px',

    [theme.breakpoints.down(820)]: {
      minWidth: '30px',
      padding: '12px',
      height: '38px',

      '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: 0,
      }
    },
  },
  textField: {
    minWidth: '137px',
    width: '145px',

    '& .MuiFormHelperText-contained': {
      position: 'absolute',
      width: '300px',
      bottom: '0px',
      margin: 0
    },

    '& .MuiInputBase-input': {
      [theme.breakpoints.down(820)]: {
        fontSize: '15px'
      },
    }
  },
}));
